import { render, staticRenderFns } from "./ExerciseCard.vue?vue&type=template&id=2d097c8f&scoped=true"
import script from "./ExerciseCard.vue?vue&type=script&lang=js"
export * from "./ExerciseCard.vue?vue&type=script&lang=js"
import style0 from "./ExerciseCard.vue?vue&type=style&index=0&id=2d097c8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d097c8f",
  null
  
)

export default component.exports